export const ALERT_CLEAR = 'alert-clear';
export const ALERT_ERROR = 'alert-error';
export const ALERT_NOTIFICATION = 'alert-notification';
export const ALERT_WARNING = 'alert-warning';

import { closeUI } from './chatInitAction';

function alertAction(type, payload, sticky = false, showReload = false) {
  return { type, payload, sticky, showReload };
}

export function error(payload, sticky = false, showReload = false) {
  return dispatch => {
      dispatch(alertAction(ALERT_ERROR, ...arguments));
      dispatch(closeUI());
    }
}

export function warning(payload, sticky = false, showReload = false) {
  return alertAction(ALERT_WARNING, ...arguments);
}

export function notification(payload, sticky = false, showReload = false) {
  return alertAction(ALERT_NOTIFICATION, ...arguments);
}

export function clearAlert(payload, sticky = false, showReload = false) {
  return alertAction(ALERT_CLEAR, ...arguments);
}



// WEBPACK FOOTER //
// ./src/redux/actions/alertAction.jsx